<app-alert-modal *ngIf="commonService.isBrowser" #creatorRequirementsModal dynamicClass="requirements-modal"
  [closeModalOnSuccess]="false" [showConfirmationBtn]="false">
  <div class="review-information">
    <div>
      <h3 class="hdn mb-0">{{ consts.TOPFAN_HDN }}</h3>
    </div>
    <div class="options">
      <div *ngFor="let item of consts.MAIN_REQUIREMENTS">
        <div class="option">
          <div class="tick-mark">
            <em class="icon-litewhite-tick-mark"></em>
          </div>
          <p class="para">{{ item }}</p>
        </div>
      </div>
    </div>
    <div class="note">{{ consts.MANUAL_REVIEW }}</div>
    <div class="agreement">
      <app-checkbox [form]="consentForm" [field]="consentCheckbox"
        (checkboxClicked)="isChecked = !isChecked"></app-checkbox>
      <div>
        {{ consts.AGREEMENT.YOU_AGREE }}
        <span (click)="openLink(consts.TERMS)">
          {{ consts.AGREEMENT.TERMS_OF_SERVICE }}
          {{ consts.AGREEMENT.CONTENT_GUIDELINES }}
        </span>

      </div>
    </div>
  </div>
  <div class="bca-btn" *ngIf="!isCreatorsHomePage">
    <app-button (click)="closeModal()" [btnField]="{
        type: 'button',
        class: 'btn btn-default',
        label: consts.CANCEL
      }"></app-button>
    <app-button (click)="navigate()" [btnField]="{
        type: 'button',
        class: 'btn btn-primary',
        label: consts.APPLY_BTN,
        disabled: !isChecked
      }"></app-button>
  </div>

  <div class="creator-requirement-continue-btn" *ngIf="isCreatorsHomePage">
    <button [disabled]="!isChecked" (click)="onRequirementContinue()" type="button" class="btn btn-primary">
      {{ AUTH_CONTANTS.CONTINUE_UPPER }}
    </button>
  </div>
</app-alert-modal>